import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Breadcrumbs,
  Link as MuiLink
} from '@mui/material';
import { Link } from 'react-router-dom';

export const AvisoLegalPage = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      py: 4, 
      backgroundColor: '#f5f5f5' 
    }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 4 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <MuiLink 
              component={Link} 
              to="/"
              underline="hover"
              color="inherit"
            >
              Inicio
            </MuiLink>
            <Typography color="text.primary">Aviso Legal y Política de privacidad</Typography>
          </Breadcrumbs>
        </Box>

        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 3, md: 5 }, 
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}
        >
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 700, 
              color: '#1a237e',
              mb: 4
            }}
          >
            Aviso Legal y Política de privacidad
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 4, color: '#303f9f' }}>
            1. INFORMACIÓN AL USUARIO
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            ¿Quién es el responsable del tratamiento de tus datos personales?
          </Typography>
          <Typography paragraph>
            Arrigal 11 S.L. es el RESPONSABLE del tratamiento de los datos personales del USUARIO y le informa de que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD).
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            ¿Para qué tratamos tus datos personales?
          </Typography>
          <Typography paragraph>
            Para mantener una relación comercial con el usuario. Las operaciones previstas para realizar el tratamiento son:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>
              <Typography paragraph>
                Remisión de comunicaciones comerciales publicitarias por e-mail, fax, SMS, MMS, redes sociales o cualquier otro medio electrónico o físico, presente o futuro, que posibilite realizar comunicaciones comerciales. Estas comunicaciones serán realizadas por el RESPONSABLE y estarán relacionadas con sus productos y servicios, o de sus colaboradores o proveedores, con los que este haya alcanzado algún acuerdo de promoción. En este caso, los terceros nunca tendrán acceso a los datos personales.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Realizar estudios de mercado y análisis estadísticos.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Tramitar encargos, solicitudes, dar respuesta a las consultas o cualquier tipo de petición que sea realizada por el USUARIO a través de cualquiera de las formas de contacto que se ponen a su disposición en la página web del RESPONSABLE.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Remitir el boletín informativo online, sobre novedades, ofertas y promociones en nuestra actividad.
              </Typography>
            </li>
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            ¿Por qué motivo podemos tratar tus datos personales?
          </Typography>
          <Typography paragraph>
            Porque el tratamiento está legitimado por el artículo 6 del GDPR de la siguiente forma:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>
              <Typography paragraph>
                Con el consentimiento del USUARIO: remisión de comunicaciones comerciales y del boletín informativo.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Por interés legítimo del RESPONSABLE: realizar estudios de mercado, análisis estadísticos, etc. y tramitar encargos, solicitudes, etc. a petición del USUARIO.
              </Typography>
            </li>
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            ¿Durante cuánto tiempo guardaremos tus datos personales?
          </Typography>
          <Typography paragraph>
            Se conservarán durante no más tiempo del necesario para mantener el fin del tratamiento o existan prescripciones legales que dictaminen su custodia y cuando ya no sea necesario para ello, se suprimirán con medidas de seguridad adecuadas para garantizar la anonimización de los datos o la destrucción total de los mismos.
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            ¿A quién facilitamos tus datos personales?
          </Typography>
          <Typography paragraph>
            No está prevista ninguna comunicación de datos personales a terceros salvo, si fuese necesario para el desarrollo y ejecución de las finalidades del tratamiento, a nuestros proveedores de servicios relacionados con comunicaciones, con los cuales el RESPONSABLE tiene suscritos los contratos de confidencialidad y de encargado de tratamiento exigidos por la normativa vigente de privacidad.
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            ¿Cuáles son tus derechos?
          </Typography>
          <Typography paragraph>
            Los derechos que asisten al USUARIO son:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>
              <Typography paragraph>
                Derecho a retirar el consentimiento en cualquier momento.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Derecho de acceso, rectificación, portabilidad y supresión de sus datos, y de limitación u oposición a su tratamiento.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Derecho a presentar una reclamación ante la autoridad de control (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.
              </Typography>
            </li>
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600, mt: 3 }}>
            Datos de contacto para ejercer sus derechos:
          </Typography>
          <Typography paragraph>
            Arrigal 11 S.L.. Calle Evaristo San Miguel, 8 4 Dª – 28008 Madrid . E-mail: info@estarmejor.es.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 5, color: '#303f9f' }}>
            2. CARÁCTER OBLIGATORIO O FACULTATIVO DE LA INFORMACIÓN FACILITADA POR EL USUARIO
          </Typography>
          <Typography paragraph>
            Los USUARIOS, mediante la marcación de las casillas correspondientes y la entrada de datos en los campos, marcados con un asterisco (*) en el formulario de contacto o presentados en formularios de descarga, aceptan expresamente y de forma libre e inequívoca, que sus datos son necesarios para atender su petición, por parte del prestador, siendo voluntaria la inclusión de datos en los campos restantes. El USUARIO garantiza que los datos personales facilitados al RESPONSABLE son veraces y se hace responsable de comunicar cualquier modificación de los mismos.
          </Typography>
          <Typography paragraph>
            El RESPONSABLE informa de que todos los datos solicitados a través del sitio web son obligatorios, ya que son necesarios para la prestación de un servicio óptimo al USUARIO. En caso de que no se faciliten todos los datos, no se garantiza que la información y servicios facilitados sean completamente ajustados a sus necesidades.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 5, color: '#303f9f' }}>
            3. MEDIDAS DE SEGURIDAD
          </Typography>
          <Typography paragraph>
            Que de conformidad con lo dispuesto en las normativas vigentes en protección de datos personales, el RESPONSABLE está cumpliendo con todas las disposiciones de las normativas GDPR y LOPDGDD para el tratamiento de los datos personales de su responsabilidad, y manifiestamente con los principios descritos en el artículo 5 del GDPR, por los cuales son tratados de manera lícita, leal y transparente en relación con el interesado y adecuados, pertinentes y limitados a lo necesario en relación con los fines para los que son tratados.
          </Typography>
          <Typography paragraph>
            El RESPONSABLE garantiza que ha implementado políticas técnicas y organizativas apropiadas para aplicar las medidas de seguridad que establecen el GDPR y la LOPDGDD con el fin de proteger los derechos y libertades de los USUARIOS y les ha comunicado la información adecuada para que puedan ejercerlos.
          </Typography>
          <Typography paragraph>
            Para más información sobre las garantías de privacidad, puedes dirigirte al RESPONSABLE a través de Arrigal 11 S.L.. Calle Evaristo San Miguel, 8 4 Dª – 28008 Madrid . E-mail: info@estarmejor.es
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};
